import { NewPermission } from 'app/core/enums/permission';
import { User } from 'app/core/models';

export class SetPermissions {
  static readonly type = '[User] Set Permissions';

  constructor(public permissions: NewPermission[]) {}
}

export class SetUser {
  static readonly type = '[User] Set User';

  constructor(public user: User) {}
}

export class SetUsers {
  static readonly type = '[User] Set Users';

  constructor(public users: User[]) {}
}

export class UpdateUserDefaultItemsPerPage {
  static readonly type = '[User] Update User Default Items Per Page';

  constructor(public pageSize: number) {}
}

export class SetUserStyleSettings {
  static readonly type = '[User] Set User Style Settings';

  constructor(public styleSettings: 'compact' | 'small' | 'normal') {}
}
